import { getDataAll as apiGetDataAll } from 'api/Api'
import {
  setLoadStatus,
  addArray
} from '../redux/dates'
import {
  setStartDate as setCardStartDate,
  setStartDateId as setCardStartDateId
} from 'routes/Board/redux/cards'
import {
  add as addAlarm
} from 'store/redux/alarms'
import { sagaActions as rootSagaActions } from 'store/sagas'

type Payload = {
  cardId: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { cardId } = payload
  
  dispatch(setLoadStatus({
    cardId,
    isLoading: true,
    isLoaded: false
  }))

  const state = getState()

  const arePersonalDatesLoaded = state.kanbo.personalDates.isLoaded
  const arePersonalDatesLoading = state.kanbo.personalDates.isLoading

  try {
    const promises = [
      apiGetDataAll([
        {
          method: 'CustomDates',
          args: {
            cardId,
            limit: 9999
          }
        },
        {
          method: 'CardsOverlay',
          args: {
            cardIds: [cardId],
            field: 'StartDate'
          }
        },
        {
          method: 'Alarms',
          args: {
            cardId
          }
        }
      ])
    ]

    if (!arePersonalDatesLoaded && !arePersonalDatesLoading) {
      promises.push(dispatch(rootSagaActions.fetchPersonalDates()))
    }

    const [
      [
        { Events: CustomDates },
        { Cards: StartDateCards },
        { Alarms }
      ]
    ] = await Promise.all(promises)

    dispatch([
      addArray({
        cardId,
        array: CustomDates.map(CustomDate => ({
          id: CustomDate.Id,
          timestamp: CustomDate.Timestamp,
          name: CustomDate.Name
        }))
      }),
      setCardStartDate({
        id: cardId,
        startDate: StartDateCards[cardId] ? StartDateCards[cardId].Date : null
      }),
      setCardStartDateId({
        id: cardId,
        startDateId: StartDateCards[cardId] ? StartDateCards[cardId].EventId : null
      }),
      ...Alarms.map(Alarm => addAlarm({
        id: Alarm.Id,
        eventId: Alarm.EventId,
        timestamp: Alarm.Timestamp,
        isDefault: Alarm.IsDefault
      })),
      setLoadStatus({
        cardId,
        isLoading: false,
        isLoaded: true
      })
    ])
  } catch (error) {
    dispatch(setLoadStatus({
      cardId,
      isLoading: false,
      isLoaded: false
    }))

    throw error
  }
}
